import {
  Button,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@mevaser/ui'
import { BellOff, PhoneIncoming } from 'lucide-react'
import { useSoftphone } from './softphone-provider.js'

/**
 * Header control for which of this staff member's browsers ring for incoming
 * customer calls (t1239). The choice is per browser and remembered on it; the
 * other open browsers are listed so it is clear where a call will ring.
 */
export function RingDevicesMenu() {
  const { available, ringHere, setRingHere, soundBlocked, thisDeviceLabel, otherDevices } =
    useSoftphone()
  if (!available) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Incoming calls on this browser">
          {ringHere ? <PhoneIncoming /> : <BellOff />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-64">
        <DropdownMenuLabel>Incoming calls</DropdownMenuLabel>
        <DropdownMenuCheckboxItem checked={ringHere} onCheckedChange={setRingHere}>
          Ring on this browser ({thisDeviceLabel})
        </DropdownMenuCheckboxItem>
        {ringHere && soundBlocked ? (
          <p className="max-w-64 px-2 py-1.5 text-xs text-foreground-muted">
            Tap anywhere on this page once so this browser can ring out loud.
          </p>
        ) : null}
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Your other open browsers</DropdownMenuLabel>
        {otherDevices.length === 0 ? (
          <p className="px-2 py-1.5 text-xs text-foreground-muted">None open</p>
        ) : (
          otherDevices.map((device) => (
            <p key={device.deviceKey} className="flex justify-between gap-4 px-2 py-1.5 text-sm">
              <span>{device.label}</span>
              <span className="text-xs text-foreground-muted">
                {device.ringIncoming === false ? 'silenced' : 'rings'}
              </span>
            </p>
          ))
        )}
        <DropdownMenuSeparator />
        <p className="max-w-64 px-2 py-1.5 text-xs text-foreground-muted">
          Change a browser's setting on that browser. If none of your browsers ring, calls go to the
          next person on the ring list.
        </p>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
